module.exports = __webpack_public_path__ + "img/ccompany-honor-MHRA-20241028.1ccdd46b.jpg";